import { Pipe, PipeTransform } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'methodOfReservation',
  standalone: false,
})
export class MethodOfReservationPipe implements PipeTransform {

  constructor(
    private translate: TranslateService
  ) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.RESERVATION_METHOD_FIRST:
        type = this.translate.instant('先着順');
        break;
      case AppConst.RESERVATION_METHOD_ON_HOLD:
        type = this.translate.instant('保留');
        break;
        case AppConst.RESERVATION_METHOD_LOTTERY:
      default:
        type = this.translate.instant('抽選');
        break;
    }
    return type;
  }

}
